jQuery.expr[':'].contains = function(a, i, m) {
    return jQuery(a).text().toUpperCase()
    .indexOf(m[3].toUpperCase()) >= 0;
};

jQuery.expr[':'].hasCountry = function(a, i, m) {
    if (jQuery(a).data('countries') !== undefined ) {
        return jQuery(a).data('countries').indexOf(m[3] + ',') >= 0;
    } else {
        return false;
    }
};

jQuery(document).ready(function ($) {
    $('.haus-evoko-deals-search-input').keyup(function () {
        var $input = $(this);
        var val = $input.val();

        if (val.trim() === '' && $('.haus-evoko-deals-select-input').val() === 'all') {
            $('.haus-evoko-deals-list .dealers').hide();
            $('.haus-evoko-deals-list .filter-first').show();
            return;
        }

        $('.haus-evoko-deals-list .dealers').css('display', 'flex');
        $('.haus-evoko-deals-list .filter-first').hide();

        var select = $('.haus-evoko-deals-select-input').val() !== 'all' ? ':hasCountry("country_' + $('.haus-evoko-deals-select-input').val() + '")' : '';

        $('.haus-evoko-deals-list .dealers .dealer').hide();
        $('.haus-evoko-deals-list .dealers .dealer:contains("'+val+'")' + select).show();
    });

    $('.haus-evoko-deals-select-input').change(function() {
        var val = $(this).val();

        if (val === 'all' && $('.haus-evoko-deals-search-input').val().trim() === '') {
            $('.haus-evoko-deals-list .dealers').hide();
            $('.haus-evoko-deals-list .filter-first').show();
            return;
        }

        $('.haus-evoko-deals-list .dealers').css('display', 'flex');
        $('.haus-evoko-deals-list .filter-first').hide();

        var search = $('.haus-evoko-deals-search-input').val().trim() !== '' ? ':contains("' + $('.haus-evoko-deals-search-input').val() + '")' : '';
        
        if (val === 'all') {
            $('.haus-evoko-deals-list .dealers .dealer' + search).show();
        } else {
            $('.haus-evoko-deals-list .dealers .dealer').hide();
            $('.haus-evoko-deals-list .dealers .dealer:hasCountry("country_'+val+'")' + search).show();
        }
    });
});